export { default } from './get-onboarding-config';
